<script>
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";

export default {
  mixins: [Api, Sabit],
  props: ["DonemId", "DetayId", "excel_kontrol", "TipeGore_Donemler"],
  data() {
    return {
      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      TableData: [],
      donemler: [],
      donemidler: [],
      TabloVerileri: [],
      modalid: "0",
      AllHedefData: [],
      keys: [],
      birimler: [],
      veriler: [],
      GostergeBirimleri: {},
      uri: "data:application/vnd.ms-excel;base64,",
      template:
        '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--> <meta charset="utf-8"></head><body><table>{table}</table></body></html>',
      base64: function(s) {
        return window.btoa(unescape(encodeURIComponent(s)));
      },
      format: function(s, c) {
        return s.replace(/{(\w+)}/g, function(m, p) {
          return c[p];
        });
      },
    };
  },
  component: {},

  watch: {},

  methods: {
    Get() {
      let Filter =
        "&TabloDetayIds=" +
        this.DetayId +
        "&PerformansDonemUstId=" +
        this.DonemId;
      this.ActionsFilterGet({
        Service: "StrPerfRaporGiris/GrafikDetay",
        Page: this.Page,
        Filter: Filter,
      }).then((res) => {
        this.TableData = [];
        this.TableData = res.Data;

        for (var i = 0; i < this.TableData.length; i++) {
          var detay_varmi = 0;
          if (this.TableData[i].DetayVar > 0) {
            detay_varmi = 1;
          }

          let KayitKontrol = this.donemler.filter((notification) =>
            notification.DonemAdi.includes(this.TableData[i].DonemAdi)
          )[0];

          // var donemvarmi = this.donemler.indexOf({"DonemAdi":this.TableData[i].DonemAdi,"DetayVar":detay_varmi});
          var tipkontrol = this.TipeGore_Donemler.indexOf(
            this.TableData[i].DonemId
          );

          if (!KayitKontrol && tipkontrol >= 0) {
            this.donemler.push({
              DonemAdi: this.TableData[i].DonemAdi,
              DetayVar: detay_varmi,
              DonemBasTar: this.TableData[i].DonemBaslamaTarihi,
              Id: this.TableData[i].DonemId,
            });
            this.donemidler.push(this.TableData[i].DonemId);
          }

          this.donemler = this.donemler.sort(function(a, b) {
            return new Date(a.DonemBasTar) - new Date(b.DonemBasTar);
          });

          var birimvarmi = this.birimler.indexOf(this.TableData[i].BirimAdi);

          if (birimvarmi < 0) {
            this.birimler.push(this.TableData[i].BirimAdi);
          }
        }

        let data = [];
        this.veriler = [];

        for (var s = 0; s < this.birimler.length; s++) {
          data = [];
          data.push(this.birimler[s]);

          for (var e = 0; e < this.donemler.length; e++) {
            let durum = 0;

            for (i = 0; i < this.TableData.length; i++) {
              if (
                this.TableData[i].BirimAdi == this.birimler[s] &&
                this.TableData[i].DonemAdi == this.donemler[e].DonemAdi
              ) {
                data.push(this.TableData[i].Toplam);
                durum = 1;
              }
            }
            if (durum == 0) {
              data.push(0);
              durum = 0;
            }
          }

          this.veriler.push(data);
          let Page = {
            PageNumber: "1",
            PageSize: "9999",
          };

          this.ActionsFilterGet({
            Service: "StrPerfTablolarDetayParametreHedefTanim",
            Page: Page,
            Filter: "&UstidDoluMu=true",
          }).then((resp) => {
            this.AllHedefData = [];
            var Data = resp.Data.sort((a, b) => a.Sira - b.Sira);
            for (var i = 0; i < Data.length; i++) {
              this.AllHedefData.push({
                id: Data[i].Id,
                label: Data[i].Hedefadi,
              });
            }
          });
        }
      });
    },
    WhicHedef(data) {
      var label = "";
      for (var i = 0; i < this.AllHedefData.length; i++) {
        if (data == this.AllHedefData[i].id) {
          label = this.AllHedefData[i].label;
        }
      }
      return label;
    },
    donem_detay_sorgula(Donemid, Tablodetayid) {
      let Page = {
        PageNumber: "1",
        PageSize: "9999",
      };

      this.modalid = "Modal" + Tablodetayid;

      setTimeout(() => {
        let Filter = "&Donemid=" + Donemid + "&Tablodetayid=" + Tablodetayid;

        this.ActionsFilterGet({
          Service: "StrPerfTablolarDetayParametreGiris/GetPivotByDonemTumBirim",
          Page: Page,
          Filter: Filter,
        }).then((res) => {
          this.TabloVerileri = res;
          this.keys = Object.keys(res[0]);
        });

        this.$bvModal.show(this.modalid);
      }, 1000);
    },
    birim_detay_sorgula(Birimid, Tablodetayid) {
      let Page = {
        PageNumber: "1",
        PageSize: "9999",
      };

      this.modalid = "Modal" + Tablodetayid;

      setTimeout(() => {
        let Filter =
          "&Birimid=" +
          Birimid +
          "&Tablodetayid=" +
          Tablodetayid +
          "&Ustdonemid=" +
          this.DonemId;

        this.ActionsFilterGet({
          Service: "StrPerfTablolarDetayParametreGiris/GetPivotByUstDonemId",
          Page: Page,
          Filter: Filter,
        }).then((res) => {
          this.TabloVerileri = res;
          this.keys = Object.keys(res[0]);
        });

        this.$bvModal.show(this.modalid);
      }, 1000);
    },
    birim_detay_varmi(birim) {
      let KayitKontrol = this.TableData.filter((notification) =>
        notification.BirimAdi.includes(birim)
      )[0];

      if (KayitKontrol) {
        return KayitKontrol;
      }
    },

    ExcelExportDetay(table, name) {
      if (!table.nodeType) table = this.$refs.GostergeDetayTablosu;
      var html = table.innerHTML;
      var ctx = { worksheet: name || "Worksheet", table: html };
      var a = document.createElement("a");
      a.href = this.uri + this.base64(this.format(this.template, ctx));
      a.download = name + ".xls";
      a.click();
    },

    ExcelExportDetayAlt(table, name) {
      if (!table.nodeType) table = this.$refs.GostergeDetayGirisTablosu;
      var html = table.innerHTML;
      var ctx = { worksheet: name || "Worksheet", table: html };
      var a = document.createElement("a");
      a.href = this.uri + this.base64(this.format(this.template, ctx));
      a.download = name + ".xls";
      a.click();
    },
  },
  created() {
    this.Get();
    let Page = {
      PageNumber: "1",
      PageSize: "9999",
    };
    this.ActionsFilterGet({
      Service: "strbirimgosterge",
      Page: Page,
      Filter: "&Gostergeid=" + this.DetayId + "&Donemid=" + this.DonemId,
    }).then((resbirims) => {
      this.GostergeBirimleri = resbirims.Data;
    });
  },
};
</script>
<template>
  <div>
    <div v-if="excel_kontrol == 0" class="text-sm-end">
      <button
        type="button"
        class="btn btn-success btn-rounded mb-2 me-2"
        @click="
          ExcelExportDetay('Gösterge Detay Tablosu', 'Gösterge Detay Tablosu')
        "
      >
        <i class="mdi mdi-file-export-outline me-1"></i>
        Excel'e Aktar
      </button>
    </div>

    <table
      ref="GostergeDetayTablosu"
      class="table table-striped table-bordered mb-0"
    >
      <thead>
        <tr>
          <th scope="col">Birim Adı</th>
          <th v-for="(donem, index) in donemler" :key="index" scope="col">
            {{ donem.DonemAdi }}

            <button
              v-if="donem.DetayVar > 0"
              type="button"
              class="btn btn-light btn-label"
              @click="donem_detay_sorgula(donem.Id, DetayId)"
            >
              <i class="mdi mdi-order-bool-descending  label-icon"></i>
              D
            </button>
          </th>

          <th>Detay</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="birim_veriler in veriler" :key="birim_veriler.Id">
          <td v-for="veri in birim_veriler" :key="veri.Id">{{ veri }}</td>
          <td>
            <button
              v-if="birim_detay_varmi(birim_veriler[0]).DetayVar > 0"
              type="button"
              class="btn btn-light btn-label"
              @click="
                birim_detay_sorgula(
                  birim_detay_varmi(birim_veriler[0]).BirimId,
                  DetayId
                )
              "
            >
              <i class="mdi mdi-order-bool-descending  label-icon"></i>
              Detay
            </button>
          </td>
        </tr>
      </tbody>
    </table>

    <b-modal :id="modalid" size="xl" title-class="font-18" hide-footer>
      <div v-if="excel_kontrol == 0" class="text-sm-end">
        <button
          type="button"
          class="btn btn-success btn-rounded mb-2 me-2"
          @click="
            ExcelExportDetayAlt(
              'Gösterge Detay Giriş Tablosu',
              'Gösterge Detay Giriş Tablosu'
            )
          "
        >
          <i class="mdi mdi-file-export-outline me-1"></i>
          Excel'e Aktar
        </button>
      </div>

      <div class="table-responsive">
        <table
          ref="GostergeDetayGirisTablosu"
          class="table table-striped table-bordered mb-0"
        >
          <tbody>
            <tr>
              <template v-for="(Data, index) in keys">
                <th
                  :key="index"
                  v-if="Data != 'groupguid' && Data != 'TotalCount'"
                  scope="col"
                >
                  <div>{{ Data }}</div>
                </th>
              </template>
            </tr>

            <tr v-for="Data in TabloVerileri" :key="Data.Id">
              <template v-for="(fild, index) in Data">
                <td
                  :key="index"
                  v-if="index != 'groupguid' && index != 'TotalCount'"
                >
                  <div v-if="fild == null"></div>
                  <div v-else>
                    <div v-if="fild[0] != '['">{{ fild }}</div>
                    <div v-if="fild[0] == '['">
                      <div
                        v-for="(subfild, index3) in JSON.parse(fild)"
                        :key="index3"
                      >
                        {{ WhicHedef(subfild) }}
                      </div>
                    </div>
                  </div>
                </td>
              </template>
            </tr>
          </tbody>
        </table>
      </div>
    </b-modal>
  </div>
</template>
